// extracted by mini-css-extract-plugin
export default {"authInputOtp":"Step2OtpVerify_authInputOtp__tMKkF","otpBoxClass":"Step2OtpVerify_otpBoxClass__6qS4N","otpPageParagraph":"Step2OtpVerify_otpPageParagraph__FfRBG"};